/* React */
import React from "react";

/* Ionic */
import {
  IonItem,
  // InputInputEventDetail,
} from "@ionic/react";

// import type { IonInputCustomEvent } from "@ionic/core";

/* Stylesheet */
import styles from "./DropdownContainer.module.scss";

/* Interfaces */
interface DropdownContainerProps<T> {
  className?: string;
  items?: T[];
  getLabel: (item: T) => string;
  onSelect: (item: T) => void;
}

const DropdownContainer = <T,>({
  className,
  items,
  getLabel,
  onSelect,
}: DropdownContainerProps<T>) => {
  return (
    <div
      className={`${styles.dropdown_container} ${
        styles[className ?? ""]
      }`}
    >
      {items?.map((item, index) => {
        return (
          <IonItem
            key={index}
            className={styles.item}
            lines="none"
            button
            onClick={() => onSelect(item)}
          >
            <div className={styles.value}>
              {getLabel(item)}
            </div>
          </IonItem>
        );
      })}
    </div>
  );
};
export default DropdownContainer;
